import { render, staticRenderFns } from "./ScholarshipTab.vue?vue&type=template&id=87e1b58e"
import script from "./ScholarshipTab.vue?vue&type=script&lang=js"
export * from "./ScholarshipTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports